import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * Slider Module
 * utilizes TinySlider package
 * to get things sliding
 */
export default class {
  /**
   * create TinySlider instance and wire navigation styling callbacks up
   */
  constructor() {
    this.sliderContainer = document.querySelector('[data-lawyer-slider]');
    this.currentSlideElement = document.querySelector('[data-lawyer-slide-number]');

    if (this.sliderContainer) {
      this.sliderLawyers = tns({
        container: this.sliderContainer,
        items: 1,
        responsive: {
          768: {
            items: 2,
          },
        },
        controls: true,
        nav: true,
        controlsPosition: 'bottom',
        mouseDrag: true,
        preventScrollOnTouch: 'auto',
        prevButton: '[data-lawyer-prev]',
        nextButton: '[data-lawyer-next]',
        arrowKeys: true,
      });
    }
  }
}
